

































































































































































import { Vue, Component, Prop } from "vue-property-decorator";
import { ReportVisiteInfo } from "../../_models/reportVisiteInfo";
import * as user from "../../_store/user.module";
import { UserInfo } from "../../_models/userInfo";

@Component
export default class DetailsReportVisita extends Vue {
  @Prop() info!: ReportVisiteInfo;
  private userRole: any;
  private status: string;

  constructor() {
    super();
    this.userRole = [];
    this.status = "";
  }

  created() {
    var userInfo: UserInfo = user.readUserInfo(this["$store"]);
    this.userRole = userInfo.ruoloUtente;
    switch (this.info.idStatoAccettazione) {
      case 1:
        this.status = "In attesa di accettazione";
        break;
      case 2:
        this.status = "Confermato";
        break;
      case 3:
        this.status = "Rifiutato";
        break;
    }
  }
}
